import {useRoutes} from "react-router-dom";
import {lazy} from "react";
import {LoadComponent} from "@loadComponent";
import {$subTitle} from "_layout/Client/Header";

const Room = lazy(() => import('./Room'));

const Hearing = () => {
    $subTitle.set('Audiência');
    return useRoutes([
        {
            path: ':id',
            element: <LoadComponent component={Room} />
        }
    ]);
};


export default Hearing;
